import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CartItem {
  product: any;
  quantity: number;
  notes?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private itemsSubject = new BehaviorSubject<CartItem[]>([]);

  items$ = this.itemsSubject.asObservable();

  getItems(): CartItem[] {
    return this.itemsSubject.value;
  }

  add(
    product: any,
    quantity: number = 1,
    notes: string = ''
  ): void {

    const items = [...this.getItems()];

    // Mesmo produto + mesma observação = soma quantidade
    const existing = items.find(
      item =>
        item.product.id === product.id &&
        (item.notes || '') === (notes || '')
    );

    if (existing) {

      existing.quantity += quantity;

    } else {

      items.push({
        product,
        quantity,
        notes
      });

    }

    this.itemsSubject.next(items);
  }







setItemQuantity(product: any, quantity: number, notes: string = ''): void {
  const items = [...this.getItems()];

  const existing = items.find(
    item =>
      item.product.id === product.id &&
      (item.notes || '') === (notes || '')
  );

  if (existing) {
    existing.quantity = quantity;
  } else {
    items.push({
      product,
      quantity,
      notes
    });
  }

  this.itemsSubject.next(items);
}




  remove(productId: number, notes: string = ''): void {

    const items = this.getItems().filter(item => !(
      item.product.id === productId &&
      (item.notes || '') === (notes || '')
    ));

    this.itemsSubject.next(items);
  }

  changeQuantity(
    productId: number,
    quantity: number,
    notes: string = ''
  ): void {

    const items = [...this.getItems()];

    const item = items.find(
      i =>
        i.product.id === productId &&
        (i.notes || '') === (notes || '')
    );

    if (!item) {
      return;
    }

    item.quantity = quantity;

    if (item.quantity <= 0) {

      this.remove(productId, notes);
      return;

    }

    this.itemsSubject.next(items);
  }

  clear(): void {
    this.itemsSubject.next([]);
  }

  total(): number {

    return this.getItems().reduce((total, item) => {

      return total + Number(item.product.price) * item.quantity;

    }, 0);

  }

}

